import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography,
} from "@mui/material";
import { useTranslate } from "@tolgee/react";
import React from "react";
import { RestrictedByCapabilityWithDebug } from "../../auth/RestrictedByCapability.js";
import { useOrganisationTeams_TeamsQuery } from "../../main-routes/my-organisation/OrganisationTeams.generated.js";
import { TeamsCellTeam } from "./TeamsCell.js";

interface Props {
  value: string | null;
  currentTeam: TeamsCellTeam | null | undefined;
  disabled?: boolean;
  onChange: (teamId: string | null) => void;
}

const NONE_VALUE = "__none__";

export const TeamSelectField = ({
  value,
  currentTeam,
  disabled,
  onChange,
}: Props) => {
  const { t } = useTranslate("Quote");

  const { data } = useOrganisationTeams_TeamsQuery({
    variables: { limit: 1000, filters: { includeInactive: false } },
  });

  const activeTeams =
    data?.teams?.__typename === "TeamConnection"
      ? data.teams.edges.map(e => e.node)
      : [];

  const selected = value ?? NONE_VALUE;
  const showDeactivatedCurrent =
    currentTeam && !currentTeam.isActive && currentTeam.id === value;

  return (
    <RestrictedByCapabilityWithDebug capability="teams">
      <Stack spacing={0.5}>
        <FormControl fullWidth size="small" disabled={disabled}>
          <InputLabel id="team-select-field-label">{t("Team")}</InputLabel>
          <Select
            labelId="team-select-field-label"
            label={t("Team")}
            value={selected}
            onChange={e => {
              const v = e.target.value as string;
              onChange(v === NONE_VALUE ? null : v);
            }}
          >
            <MenuItem value={NONE_VALUE}>{t("None")}</MenuItem>
            {showDeactivatedCurrent && currentTeam && (
              <MenuItem value={currentTeam.id}>
                {currentTeam.name} ({t("Deactivated")})
              </MenuItem>
            )}
            {activeTeams.map(option => (
              <MenuItem key={option.id} value={option.id}>
                {option.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {showDeactivatedCurrent && (
          <Typography
            variant="caption"
            sx={{
              color: "text.secondary",
            }}
          >
            {t("This team is deactivated")}
          </Typography>
        )}
      </Stack>
    </RestrictedByCapabilityWithDebug>
  );
};
